import { noCase } from './noCase';

import type { IChangeCaseOptions } from './noCase';

export type { IChangeCaseOptions };

export function paramCase(input: string, options: IChangeCaseOptions = {}) {
  return noCase(input, {
    delimiter: '-',
    ...options
  });
}
